import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UMenubarComponent } from './u-menubar.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [UMenubarComponent],
  imports: [CommonModule, MatMenuModule, MatIconModule, MatButtonModule],
  exports: [UMenubarComponent],
})
export class UMenubarModule {}
